import React, { useState } from 'react';
import { Search, Loader, FileText, AlertCircle, Download } from 'lucide-react';
import { query, downloadDocumento } from '../api';

export default function Ricerca() {
  const [testo, setTesto] = useState('');
  const [fascicolo, setFascicolo] = useState('');
  const [carico, setCarico] = useState(false);
  const [risultato, setRisultato] = useState(null);
  const [errore, setErrore] = useState(null);

  const cerca = async (e) => {
    e.preventDefault();
    if (!testo.trim()) return;
    setCarico(true);
    setErrore(null);
    setRisultato(null);
    try {
      const r = await query({
        query: testo,
        fascicolo: fascicolo || undefined,
        limit: 5
      });
      setRisultato(r.data);
    } catch (err) {
      setErrore('Errore durante la ricerca. Riprova.');
    } finally {
      setCarico(false);
    }
  };

  return (
    <div className="pagina">
      <form onSubmit={cerca} className="form-ricerca">
        <div className="input-group">
          <input
            type="text"
            className="input-principale"
            placeholder="Fai una domanda sui documenti dello studio..."
            value={testo}
            onChange={e => setTesto(e.target.value)}
            disabled={carico}
          />
          <input
            type="text"
            className="input-filtro"
            placeholder="Filtra per fascicolo (opzionale)"
            value={fascicolo}
            onChange={e => setFascicolo(e.target.value)}
            disabled={carico}
          />
        </div>
        <button type="submit" className="btn-cerca" disabled={carico || !testo.trim()}>
          {carico ? <Loader size={18} className="spin" /> : <Search size={18} />}
          {carico ? 'Ricerca in corso...' : 'Cerca'}
        </button>
      </form>

      {errore && (
        <div className="alert errore">
          <AlertCircle size={18} />
          <span>{errore}</span>
        </div>
      )}

      {carico && (
        <div className="carico-box">
          <Loader size={32} className="spin" />
          <p>Llama 4 Scout sta elaborando la risposta...</p>
          <p className="carico-sub">Può richiedere 20–40 secondi</p>
        </div>
      )}

      {risultato && (
        <div className="risultato">
          <div className="risposta-box">
            <h3 className="risposta-titolo">Risposta</h3>
            <p className="risposta-testo">{risultato.risposta}</p>
          </div>

          {risultato.fonti?.length > 0 && (
            <div className="fonti">
              <h4 className="fonti-titolo">Fonti utilizzate</h4>
              {risultato.fonti.map((f, i) => (
                <div key={i} className="fonte-item">
                  <FileText size={14} />
                  <span className="fonte-nome">{f.nome_file}</span>
                  {f.fascicolo && <span className="fonte-fasc">· {f.fascicolo}</span>}
                  <span className="fonte-score">score: {f.score}</span>
                  {f.documento_id && (
                    <button
                      className="btn-download"
                      onClick={() => downloadDocumento(f.documento_id, f.nome_file)}
                      title="Scarica documento originale"
                    >
                      <Download size={13} />
                      Scarica
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
